import { TOKEN_COOKIE_NAME } from "../Constant"
import cookie from 'react-cookies'
import axios from 'axios'


const token = cookie.load(TOKEN_COOKIE_NAME)

export default axios.create(
    {
        baseURL:"http://localhost:8888",
        // headers:{
        //     Authorization: `Bearer ${token}`
        // }
        header: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
        }
    } 
)